<template>
  <div class="def-favourite-block">
    <span class="def-favourite" @click="handlerClick">
      <svg class="def-favourite__icon">
        <use v-if="!favouriteStore.inFavourite(id)" xlink:href="#svg-favourite"></use>
        <use v-else xlink:href="#svg-favourite-fill"></use>
      </svg>
    </span>
    <span v-if="allLikesCount > 0" class="def-favourite-block__count">
      {{ allLikesCount }}
    </span>
  </div>
</template>

<script>
import useModal from '@use/useModal/useModal';
import SignIn from '@components/Cabinet/Entry/SignIn/SignIn.vue';
import Analytics from '@/utils/Analytics/Analytics';
import { useFavouriteStore } from '@/storePinia/stores/favourite';
import { useResultsStore } from '@/storePinia/stores/results';
import { usePersonalStore } from '@/storePinia/stores/personal';

export default {
  name: 'DefFavourite',
  props: ['result'],
  data() {
    return {
      modal: useModal(),
      likesCount: null,
      favouriteStore: useFavouriteStore(),
      resultsStore: useResultsStore(),
      personalStore: usePersonalStore(),
    };
  },
  computed: {
    allLikes() {
      return this.resultsStore?.allLikes;
    },
    favourite() {
      return this.favouriteStore.favourite;
    },
    updatedLikes() {
      return this.favouriteStore.updatedLikes;
    },
    id() {
      return this.result?.offer?.id ?? this.result?.id;
    },
    allLikesCount() {
      return this?.updatedLikes?.[this?.result?.id] ?? this?.allLikes?.[this?.result?.id] ?? 0;
    },
  },
  methods: {
    async handlerClick() {
      if (this.personalStore.isAuthorized) {
        const pId = this?.result?.id;

        if (!this.favouriteStore.inFavourite(this.id)) {
          await this.favouriteStore.addLikeToBaseGroup({
            id: this.id,
          });

          this.updateAllLikesCountById(pId);

          Analytics.addToWishlist(this?.result);
        } else {
          await this.favouriteStore.remove({ id: this.id });
          this.updateAllLikesCountById(pId);
        }
      } else {
        this.modal.show(SignIn, {}, { width: '900px', backgroundClose: false });
      }
    },
    updateAllLikesCountById(id) {
      this.resultsStore.allLikes = { ...this?.allLikes, [id]: this?.allLikesCount };
    },
  },
};
</script>

<style lang="scss" scoped>
.def-favourite-block {
  display: flex;
  align-items: center;
  gap: 4px;
  &__count {
    position: relative;
    font-size: 14px;
    font-weight: 600;
    line-height: 125%;
  }
}
.def-favourite {
  display: block;
  cursor: pointer;
  &__icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    fill: var(--background-black);
  }
  &:hover {
    animation: heartbeat 1s infinite;
  }
}

@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1.25);
  }
  40% {
    transform: scale(1.5);
  }
}
</style>
